import Head from 'next/head';
import Link from 'next/link';

import { DGGeneralHelpSEO } from '@/utils/constants/MetaData';

const General = () => {
  return (
    <>
      <Head>
        <title>{DGGeneralHelpSEO.metaTitle}</title>
        <meta name="description" content={DGGeneralHelpSEO.metaDescription} />
        <meta
          property="og:description"
          content={DGGeneralHelpSEO.metaOGDescription}
        />
        <link
          rel="canonical"
          href="https://muthootfincorpone.com/help/digital-gold/general/"
        />
      </Head>
      <main className="repayment singleFlow--lightBlue pledge setting">
        <div className="container">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link href="/help">eSwarna Digital Gold Help</Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                General
              </li>
            </ol>
          </nav>
          <div className="loanDetails__card loanCard accordion setting-faq-accordion">
            <h1 className="loanCard__title text--bold text--black">General</h1>
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingOne"
                data-toggle="collapse"
                data-target="#collapseOne"
                aria-expanded="false"
                aria-controls="collapseOne"
              >
                <h2 className="text--black text--semi title">
                  What is eSwarna Digital Gold?
                </h2>
              </div>
              <div
                id="collapseOne"
                className="collapse"
                aria-labelledby="headingOne"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    eSwarna Digital Gold is the virtual method of buying and
                    investing in gold without having to physically hold the
                    gold. When you buy eSwarna Digital Gold on Muthoot FinCorp
                    ONE , the corresponding physical gold is stored at secure
                    vaults by Muthoot EXIM appointed custodian Sequel Logistics
                    completely free of cost. Your gold is always 100% safe and
                    secure at no extra cost.
                  </p>
                </div>
              </div>
            </div>
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingTwo"
                data-toggle="collapse"
                data-target="#collapseTwo"
                aria-expanded="false"
                aria-controls="collapseTwo"
              >
                <p className="text--black text--semi title">
                  What is the Purity of Gold?
                </p>
              </div>
              <div
                id="collapseTwo"
                className="collapse"
                aria-labelledby="headingTwo"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    Muthoot EXIM offers 999 fineness also known as 24 karat
                    purity through Muthoot FinCorp ONE platform.
                  </p>
                </div>
              </div>
            </div>

            <div className="setting-faq-card">
              <div
                className="header"
                id="headingLivePrice"
                data-toggle="collapse"
                data-target="#collapseLivePrice"
                aria-expanded="false"
                aria-controls="collapseLivePrice"
              >
                <p className="text--black text--semi title">
                  How safe is my gold investment?
                </p>
              </div>
              <div
                id="collapseLivePrice"
                className="collapse"
                aria-labelledby="headingLivePrice"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    Your investment is 100% safe and secure with Muthoot EXIM.
                    The physical gold is stored in secure vaults by Muthoot EXIM
                    appointed custodian Sequel Logistics.
                  </p>
                </div>
              </div>
            </div>

            <div className="setting-faq-card">
              <div
                className="header"
                id="headingEximQ"
                data-toggle="collapse"
                data-target="#collapseEximQ"
                aria-expanded="false"
                aria-controls="collapseEximQ"
              >
                <p className="text--black text--semi title">
                  What are the transaction charges applicable on eSwarna Digital
                  Gold?
                </p>
              </div>
              <div
                id="collapseEximQ"
                className="collapse"
                aria-labelledby="headingEximQ"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    On every purchase transaction GST is payable at the
                    applicable rate from time to time. No GST will be applicable
                    for sale transactions.
                  </p>
                </div>
              </div>
            </div>

            <div className="setting-faq-card">
              <div
                className="header"
                id="headingThree"
                data-toggle="collapse"
                data-target="#collapseThree"
                aria-expanded="false"
                aria-controls="collapseThree"
              >
                <p className="text--black text--semi title">
                  Can I convert my eSwarna Digital Gold to gold coins and/or
                  jewellery?
                </p>
              </div>
              <div
                id="collapseThree"
                className="collapse"
                aria-labelledby="headingThree"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    Yes, you can encash the gold purchased on Muthoot FinCorp
                    ONE platform any time after 24 working hours from the time
                    of purchase. We will soon be introducing the option to
                    convert eSwarna Digital Gold into jewellery or gold coins.
                  </p>
                </div>
              </div>
            </div>
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingFour"
                data-toggle="collapse"
                data-target="#collapseFour"
                aria-expanded="false"
                aria-controls="collapseFour"
              >
                <p className="text--black text--semi title">
                  How do I contact customer support for any issues?
                </p>
              </div>
              <div
                id="collapseFour"
                className="collapse"
                aria-labelledby="headingFour"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    Please feel free to write to us at{' '}
                    <a href="mailto:customercare@muthoot.com">
                      customercare@muthoot.com
                    </a>
                  </p>
                </div>
              </div>
            </div>
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingFive"
                data-toggle="collapse"
                data-target="#collapseFive"
                aria-expanded="false"
                aria-controls="collapseFive"
              >
                <p className="text--black text--semi title">
                  In case of death of the customer, what happens to his/her
                  eSwarna Digital Gold account?
                </p>
              </div>
              <div
                id="collapseFive"
                className="collapse"
                aria-labelledby="headingFive"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    In the event of a customer’s death, their legal heir can
                    claim the gold by submitting necessary documents to
                    establish his/her claim . Once their identity has been
                    verified we will substitute the legal heir in place of the
                    deceased customer.
                  </p>
                </div>
              </div>
            </div>
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingSix"
                data-toggle="collapse"
                data-target="#collapseSix"
                aria-expanded="false"
                aria-controls="collapseSix"
              >
                <p className="text--black text--semi title">
                  At what price is gold sold/ bought from customers?
                </p>
              </div>
              <div
                id="collapseSix"
                className="collapse"
                aria-labelledby="headingSix"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    All Buy/Sell transactions on Muthoot FinCorp ONE are based
                    on the live gold rate reflected on the app. This price is
                    locked for 4 mins and 30 secs for the customer to complete
                    the transaction. In case the transaction is not completed
                    within the given time frame, the system is refreshed with
                    the live gold rate.
                  </p>
                </div>
              </div>
            </div>
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingSeven"
                data-toggle="collapse"
                data-target="#collapseSeven"
                aria-expanded="false"
                aria-controls="collapseSeven"
              >
                <p className="text--black text--semi title">
                  What happens when payment is deducted through a
                  customer&apos;s UPI account, but the gold is not credited in
                  customers gold balance?
                </p>
              </div>
              <div
                id="collapseSeven"
                className="collapse"
                aria-labelledby="headingSeven"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    If any payment has been debited from your UPI account, and
                    the gold has not credited to your gold balance, an automatic
                    refund will be initiated by us, and the amount will be
                    credited to your bank account within 3-5 working days. For
                    further queries you may also contact our customer care team
                    at{' '}
                    <a href="mailto:customercare@muthoot.com">
                      customercare@muthoot.com
                    </a>
                  </p>
                </div>
              </div>
            </div>
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingEight"
                data-toggle="collapse"
                data-target="#collapseEight"
                aria-expanded="false"
                aria-controls="collapseEight"
              >
                <p className="text--black text--semi title">
                  What is the payment method supported for eSwarna Digital Gold?
                </p>
              </div>
              <div
                id="collapseEight"
                className="collapse"
                aria-labelledby="headingEight"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    We support UPI as the payment method for the transaction of
                    eSwarna Digital Gold on Muthoot FinCorp ONE.
                  </p>
                </div>
              </div>
            </div>
            {/* <div className="setting-faq-card">
              <div
                className="header"
                id="headingNine"
                data-toggle="collapse"
                data-target="#collapseNine"
                aria-expanded="false"
                aria-controls="collapseNine"
              >
                <p className="text--black text--semi title">
                  What happens when payment is deducted through a
                  customer&apos;s UPI account, but the gold is not credited in
                  customers&apos; gold balance?
                </p>
              </div>
              <div
                id="collapseNine"
                className="collapse"
                aria-labelledby="headingNine"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    If any payment has been debited from your UPI account, and
                    the gold is not credited in your Muthoot FinCorp ONE gold
                    balance, an automatic refund will be initiated by us and the
                    amount will be credited to your bank account within 3-5
                    working days. You may also contact our customer care team at{" "}
                    <a href="mailto:customercare@muthoot.com">
                      customercare@muthoot.com
                    </a>{" "}
                    for any further queries or status updates.
                  </p>
                </div>
              </div>
            </div> */}
            {/* <div className="setting-faq-card">
              <div
                className="header"
                id="headingTen"
                data-toggle="collapse"
                data-target="#collapseTen"
                aria-expanded="false"
                aria-controls="collapseTen"
              >
                <p className="text--black text--semi title">
                  What is the payment method supported for Digital Gold?
                </p>
              </div>
              <div
                id="collapseTen"
                className="collapse"
                aria-labelledby="headingTen"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    We support UPI as the payment method for transaction of
                    Digital Gold on Muthoot FinCorp ONE platform
                  </p>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </main>
    </>
  );
};

export default General;
